var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcInboxOnce = function SvgIcInboxOnce(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4h7.892a5 5 0 0 1 5 5v4a5 5 0 0 1-5 5h-3.18l.097 1.918a1 1 0 0 1-1.778.676L8.946 18H8a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5zm3.115 14.08a1.6 1.6 0 0 1 1.598-1.68h3.18a3.4 3.4 0 0 0 3.4-3.4V9a3.4 3.4 0 0 0-3.4-3.4H8A3.4 3.4 0 0 0 4.6 9v4A3.4 3.4 0 0 0 8 16.4h.946a1.6 1.6 0 0 1 1.247.598l.925 1.15-.003-.067zM7.5 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm5.5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "#BDBDBD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.631,
    cy: 17.631,
    r: 4.631,
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.46 17.63a.421.421 0 0 1 0 .843h-2.782a.421.421 0 0 1-.42-.421v-3.233a.421.421 0 0 1 .841 0v2.812h2.361z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcInboxOnce);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_inbox_once.1ef412a02f38a845adeb7a3613ef478c.svg";